import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import I18n from 'redux-i18n';
import history from './helpers/history';
import * as numberFormatter from 'apex-web/lib/helpers/numberFormatter';
import initAPEXWebActions from 'apex-web/lib/helpers/apexWebActions';
import { unregister } from './registerServiceWorker';
import config from './config';
import cssVars from 'css-vars-ponyfill';

import './styles/base/Fonts.css';
import './styles/base/Base.css';
import './styles/theme/variables.css';
import './styles/components/common/Divider.css';
import './styles/layout/Table.css';
import './styles/layout/Modals.css';
import './styles/layout/app.css';
import './styles/components/common/index.css';
import App from './App';
import './styles/sidePanes/SlidePane.theme.css';
import store from './redux/store';

import('./config').then(config =>
  import(`./styles/theme/${config.default.global.theme}.css`)
);

initAPEXWebActions();

numberFormatter.init({
  locale: config.global.locale,
  getDecimalPlaces: () => store.getState().product.decimalPlaces
});

window.cssVariables = {};
cssVars({
  watch: true,
  silent: true,
  onComplete: function(cssText, styleNode, cssVariables) {
    window.cssVariables = cssVariables;
  }
});

const translations = window.APEXTranslations || { en: {} };
translations.options = {
  ...translations.options,
  // It logs thousands of warnings in the console
  // so it becomes unusable - disable it.
  suppress_warnings: true
};

ReactDOM.render(
  <Provider store={store}>
    <I18n translations={translations}>
      <Router history={history}>
        <App />
      </Router>
    </I18n>
  </Provider>,
  document.getElementById('root')
);

unregister();
